import { BRAND_AWARENESS, OUTCOME_AWARENESS, REACH } from '../../../constants/campaigns'
import {
  PERFORMANCE_GOAL_TYPE_CPM,
  PERFORMANCE_GOAL_TYPE_VCPM,
  PERFORMANCE_GOAL_TYPE_VIEWABILITY
} from '../../DV360/CampaignForms/CampaignDv360Create/CampaignDv360CreateForm/fields'

export const getIsObjectiveEquivalentToReach = objective => {
  const facebookReachEquivalentObjectives = [REACH, OUTCOME_AWARENESS, BRAND_AWARENESS]
  const tiktokReachEquivalentObjectives = ['REACH']
  const dv360ReachEquivalentObjectives = [
    PERFORMANCE_GOAL_TYPE_CPM,
    PERFORMANCE_GOAL_TYPE_VIEWABILITY,
    PERFORMANCE_GOAL_TYPE_VCPM
  ]

  const reachEquivalentObjectives = [
    ...facebookReachEquivalentObjectives,
    ...tiktokReachEquivalentObjectives,
    ...dv360ReachEquivalentObjectives
  ]

  return reachEquivalentObjectives.includes(objective)
}
